import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { OptionsColor } from "../../OptionsColor";
export var GrabLinks = /*#__PURE__*/function () {
  function GrabLinks() {
    _classCallCheck(this, GrabLinks);
    this.blink = false;
    this.consent = false;
    this.opacity = 1;
  }
  _createClass(GrabLinks, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.blink !== undefined) {
        this.blink = data.blink;
      }
      if (data.color !== undefined) {
        this.color = OptionsColor.create(this.color, data.color);
      }
      if (data.consent !== undefined) {
        this.consent = data.consent;
      }
      if (data.opacity !== undefined) {
        this.opacity = data.opacity;
      }
    }
  }]);
  return GrabLinks;
}();